import store from '../../../store';
import { patchAdviserNotes } from '../../../store/clientNotes/api';
import type { AdviserNotesPatch, AdviserNotesSaved } from '../../../store/clientNotes/api';
import { getClientById, setClientFactsheetFields, updateFactSheet } from '../../../store/client/duck';

/**
 * Everything the notes store does outside itself, in one place so tests can
 * replace it with `jest.mock('./clientNotesTransport')`.
 */
export const clientNotesTransport = {
  patch: (factsheetId: string, body: AdviserNotesPatch): Promise<AdviserNotesSaved> =>
    patchAdviserNotes(factsheetId, body),
  /** The server's copy lands in the Redux list, so the next seed agrees with it. */
  saved: (factsheetId: string, fields: AdviserNotesSaved) => {
    store.dispatch(setClientFactsheetFields(factsheetId, fields));
  },
  /** After a failed write: re-read the client; the next seed brings the server copy back. */
  failed: (clientId: string) => {
    store.dispatch(getClientById(clientId));
  },
  /** 現職 / 介紹人 are root factsheet fields, written the way the drawer's 補資料 writes them. */
  writeRootField: (clientId: string, factsheetId: string, key: 'occupation' | 'referrerName', value: string) => {
    store.dispatch(updateFactSheet({ id: factsheetId, key, value, clientId }));
  }
};
